import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Clients } from './pages/Clients';
import { Invoices } from './pages/Invoices';
import { Jobs } from './pages/Jobs';
import { Account } from './pages/Account';
import { Reporting } from './pages/Reporting';
import { Settings } from './pages/Settings';
import { SignIn } from './pages/SignIn';
import { Timesheets } from './pages/Timesheets';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rit14zvovkns">
      <Routes data-id="element-1" data-mp="2mlua4q7bnttt">
        <Route path="/" element={<Navigate to="/signin" replace data-id="element-3" data-mp="2mmvjmq8ow89f" />} data-id="element-2" data-mp="2mmce69087cca" />
        <Route path="/signin" element={<SignIn data-id="element-5" data-mp="31b8ka0iq2fa9" />} data-id="element-4" data-mp="2mjzm330r7lli" />
        <Route path="/clients" element={<Clients data-id="element-7" data-mp="31c1iue7j1yhb" />} data-id="element-6" data-mp="31bs0ncsq4vm6" />
        <Route path="/jobs" element={<Jobs data-id="element-9" data-mp="2wjqi594yq8np" />} data-id="element-8" data-mp="2wk0a329kipw1" />
        <Route path="/invoices" element={<Invoices data-id="element-11" data-mp="2whxb3sqftmf6" />} data-id="element-10" data-mp="2wj8cjlweui34" />
        <Route path="/timesheets" element={<Timesheets data-id="element-13" data-mp="28te2td7e19n3" />} data-id="element-12" data-mp="28ufm24yk52fw" />
        <Route path="/reporting" element={<Reporting data-id="element-15" data-mp="23vchsmqej08z" />} data-id="element-14" data-mp="28sl3gxardmez" />
        <Route path="/settings" element={<Settings data-id="element-17" data-mp="23utas12ahw9q" />} data-id="element-16" data-mp="23w4fc33k781w" />
        <Route path="/account" element={<Account data-id="element-19" data-mp="3ikh8ubu2yx01" />} data-id="element-18" data-mp="23t8eo70bu59r" />
      </Routes>
    </BrowserRouter>;
}